import jwt from 'jsonwebtoken';

function clarityIdentify (devStatus) {
  const cookieConsent = localStorage.getItem('cookieConsent');
  if (window.clarity && cookieConsent === 'true') {
    const token = localStorage.getItem('token');
    if (token) {
      const user = jwt.decode(token);
      if (user) {
        user.stringId = String(user.uid);
        window.clarity("identify", String(user.uid));
        window.clarity("set", "email", user.email);
        if (devStatus) {
          window.clarity("set", "vetting_status", devStatus)
        }
      }
    }
  }
}

export default clarityIdentify;
